
import FormatMixin from "@/modules/Application/mixins/FormatMixin";

export default {
  name: "pdv-card-itens",
  mixins: [FormatMixin],
  data() {
    return {
      fields: [
        {
          key: "currentIndex + parseFloat(1)",
          label: "",
          sortable: true
        },
        {
          key: "product.description",
          label: "Descrição do Produto \n Código de Barras",
          sortable: true
        },
        {
          key: "quantity",
          label: "Qtd.",
          sortable: true
        },
        {
          key: "totalPrice",
          label: "Total",
          sortable: true
        }
      ],
      calculoTotal: 0
    };
  },
  props: {
    items: {
      default: []
    },
    total: {
      default: 0
    },
    acrescimo: {
      default: 0
    },
    desconto: {
      default: 0
    },
    valorPago: {
      default: 0
    },
    addQtd: {
      type: Function
    },
    substractQtd: {
      type: Function
    }
  },
  methods: {
    add(index) {
      this.addQtd(index);
    },
    substract(index) {
      this.substractQtd(index);
    },
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.calculoTotal = newValue;
      }
    }
  }
};
